import { TRAIN as Fetch } from '@/api'

// 请求课程中心内容
export const postCourseDetail = (params) => (
  Fetch({
    url: '/teacher-train-service/train/course/center/details',
    method: 'post',
    params
  })
)

// 请求用户信息是否完善
export const postImporventInformation = (params) => (
  Fetch({
    url: '/teacher-train-service/train/user/checkUser',
    method: 'post',
    params
  })
)

// 请求用户是否加入班级
export const postJoinClass = (params) => (
  Fetch({
    url: '/teacher-train-service/train/user/join',
    method: 'post',
    params
  })
)

// 请求预览习题接口
export const postPreviewExecirse = (params) => (
  Fetch({
    url: '/teacher-train-service/train/resource/paper/preview',
    method: 'post',
    params
  })
)
// 预报名保存
export const coursePreRegister = (data) => (
  Fetch({
    url: '/teacher-train-service/train/course/coursePreRegister',
    method: 'post',
    data
  })
)
